<template>
    <v-layout justify-center>
        <v-responsive max-width="480" width="100%" class="px-3 mx-n3">
            <list-heading title="무통장입금 계좌 설정" />

            <v-card outlined v-bind="{ loading }">
                <v-card-text class="py-3">
                    <template v-if="setting">
                        <v-row>
                            <v-col cols="5"> <v-autocomplete v-model="setting.shop.bank.code" label="은행" :items="banks" item-text="name" item-value="code" v-bind="attrs_input" /> </v-col>
                            <v-col cols="7"> <v-text-field v-model="setting.shop.bank.accountHolder" label="예금주" v-bind="attrs_input" /> </v-col>
                            <v-col cols="12"> <v-text-field v-model="setting.shop.bank.accountNumber" label="계좌번호" v-bind="attrs_input" /> </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-skeleton-loader type="image" />
                    </template>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="primary" v-bind="{ loading }" @click="save">저장</v-btn>
                </v-card-actions>
            </v-card>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import banks from "@/assets/data/banks.json";
import { attrs_input, initBank } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";

export default {
    components: {
        ListHeading,
    },
    data: () => ({
        setting: undefined,

        loading: false,

        banks,
        attrs_input,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                var { setting } = await api.console.setting.get();
                setting.shop = {
                    ...setting?.shop,
                    bank: initBank(setting?.shop?.bank),
                };
                this.setting = setting;
            } finally {
                this.loading = false;
            }
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const setting = JSON.parse(JSON.stringify(this.setting));
                await api.console.setting.put(setting);

                alert("저장되었습니다.");
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
